import { useHistory } from "react-router";
import AdaptiveImage from "../AdaptiveImage";

import styles from "./index.module.css";

const GlobalFooter = () => {
  const history = useHistory();

  const goHome = () => {
    history.push('/');
  };

  return (
    <div className={styles.input} onClick={goHome}>
      <AdaptiveImage className={styles.global_footer} name="global_footer" />
    </div>
  );
};

export default GlobalFooter;
